import angular from 'angular'
import Dialog from './rb-dialog.provider'
import rbOverlayService from './rb-overlay.service'
import mdCompile from './md-compile.service'

export default angular.module('rb.dialog', [ ])
  .provider('rbDialog', Dialog)
  .service('rbOverlayService', rbOverlayService)
  .service('$mdCompile', mdCompile)

